import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import extractText from 'flarum/common/utils/extractText';
import { decodeCreationOptions, serializeRegistrationCredential, isUserCancellation } from '../utils/webauthn';
export default class PasskeysSettings extends Component {
  loading = false;
  credentials = [];
  oninit() {
    this.load();
  }
  async load() {
    this.loading = true;
    try {
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('baseUrl') + '/passkeys/credentials',
        errorHandler: () => {}
      });
      this.credentials = response.data || [];
    } catch {
      this.credentials = [];
    }
    this.loading = false;
    m.redraw();
  }
  async register() {
    if (!app.forum.attribute('passkeysEnabled')) return;
    this.loading = true;
    try {
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('baseUrl') + '/passkeys/register/options',
        errorHandler: () => {}
      });
      const publicKey = decodeCreationOptions(response.publicKey);
      const credential = await navigator.credentials.create({
        publicKey
      });
      if (!credential) {
        return;
      }
      const deviceName = window.prompt(extractText(app.translator.trans('cengizkemec-passkeys.forum.settings.device_name_prompt')));
      if (deviceName === null) {
        return;
      }
      await app.request({
        method: 'POST',
        url: app.forum.attribute('baseUrl') + '/passkeys/register/verify',
        body: {
          credential: serializeRegistrationCredential(credential),
          device_name: deviceName
        },
        errorHandler: () => {}
      });
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('cengizkemec-passkeys.forum.settings.added'));
      await this.load();
    } catch (error) {
      if (!isUserCancellation(error)) {
        app.alerts.show({
          type: 'error'
        }, app.translator.trans('cengizkemec-passkeys.forum.settings.error'));
      }
    } finally {
      this.loading = false;
    }
  }
  async deleteCredential(id) {
    if (!window.confirm(extractText(app.translator.trans('cengizkemec-passkeys.forum.settings.delete_confirm')))) return;
    this.loading = true;
    try {
      await app.request({
        method: 'POST',
        url: app.forum.attribute('baseUrl') + '/passkeys/credentials/' + id + '/delete',
        errorHandler: () => {}
      });
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('cengizkemec-passkeys.forum.settings.deleted'));
      await this.load();
    } catch {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('cengizkemec-passkeys.forum.settings.error'));
    } finally {
      this.loading = false;
    }
  }
  view() {
    return m("fieldset", {
      className: "PasskeysSettings SettingsWidget"
    }, m("legend", null, app.translator.trans('cengizkemec-passkeys.forum.settings.passkeys_heading')), this.loading ? m(LoadingIndicator, null) : m("div", null, m("ul", {
      className: "PasskeysList"
    }, this.credentials.length === 0 && m("li", {
      className: "PasskeysList-item PasskeysList-item--empty"
    }, app.translator.trans('cengizkemec-passkeys.forum.settings.no_passkeys')), this.credentials.map(credential => m("li", {
      className: "PasskeysList-item",
      key: credential.id
    }, m("span", {
      className: "PasskeysList-name"
    }, m("i", {
      className: "fas fa-key",
      "aria-hidden": "true"
    }), " ", credential.device_name || app.translator.trans('cengizkemec-passkeys.forum.settings.unnamed_device')), m(Button, {
      className: "Button Button--danger Button--text",
      icon: "fas fa-trash-alt",
      onclick: () => this.deleteCredential(credential.id)
    }, app.translator.trans('cengizkemec-passkeys.forum.settings.delete'))))), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      onclick: () => this.register()
    }, app.translator.trans('cengizkemec-passkeys.forum.settings.add_passkey'))));
  }
}
flarum.reg.add('cengizkemec-passkeys', 'forum/components/PasskeysSettings', PasskeysSettings);